'use client'

import { CardGrid } from '@/components/common/CardGrid'
import { ErrorBlock } from '@/components/common/ErrorBlock'
import { NoResults } from '@/components/common/NoResults'
import { usePage } from '@/components/providers/PageProvider'

import styles from './Similiar.module.scss'

export const Similiar = () => {
  const { page } = usePage()
  const similar = page?.similar

  if (!similar) return <ErrorBlock />

  return (
    <section className={styles.container}>
      {similar.length ? <CardGrid recs={similar} /> : <NoResults size='lg' />}
    </section>
  )
}
